export enum LayerResponseType {
  Vector = 'vector',
  Orthomosaic = 'orthomosaic',
  MBTiles = 'mbtiles',
  MapBox = 'mapbox',
  Cesium = 'cesium',
  Contour = 'contour',
  SlopeMap = 'slope_map',
  CapturedDsm = 'captured_dsm',
  PointCloud = 'point_cloud',
  Cad = 'cad',
}

export enum LayerType {
  Vector = 'vector',
  Orthomosaic = 'orthomosaic',
  CapturedDsm = 'capturedDsm',
  MBTiles = 'mbtiles',
  MapBox = 'mapbox',
  Cesium = 'cesium',
  Contour = 'contour',
  SlopeMap = 'slopeMap',
  PointCloud = 'pointCloud',
  KML = 'kml',
  Cad = 'cad',
}

export enum LayerResponseClampedStatus {
  AlreadyClamped = 'already_clamped',
  Done = 'done',
  Failed = 'failed',
  NotClamped = 'not_clamped',
  Processing = 'processing',
  Started = 'started',
}

export enum LayerClampedStatus {
  AlreadyClamped = 'alreadyClamped',
  Done = 'done',
  Failed = 'failed',
  NotClamped = 'notClamped',
  Processing = 'processing',
  Started = 'started',
}

export enum AreaCategory {
  Other = 'other',
  PlannedAndActive = 'planned_and_active',
  PlannedAndInactive = 'planned_and_inactive',
  UnplannedAndActive = 'unplanned_and_active',
  UnplannedAndActiveBeyondCriticalBoundary = 'unplanned_and_active_beyond_critical_boundary',
}

export enum LayerQueryKey {
  Layers = 'layers',
}

export enum VectorFileFormat {
  ShapeFile = 'shp',
  DXF = 'dxf',
  KML = 'kml',
  KMZ = 'kmz',
  GPKG = 'gpkg',
  TIF = 'tif',
}

export enum FileType {
  BaseDsm = 'base_dsm',
  CapturedDsm = 'captured_dsm',
  LegendImage = 'legend_image',
  Orthomosaic = 'orthomosaic',
  OrthomosaicCog = 'orthomosaic_cog',
  MBTiles = 'mbtiles',
  KML = 'kml',
  CapturedDsmCog = 'captured_dsm_cog',
  Vectors = 'vectors',
  PointCloud = 'point_cloud',
  VectorTiles = 'vector_tiles',
  SlopeMap = 'slope_map',
  Temporary = 'temporary',
  IterationFile = 'iteration_file',
  Attachment = 'attachment',
  GnssFile = 'gnss_file',
  CameraLog = 'camera_log',
  Copc = 'copc',
  Spreadsheet = 'spreadsheet',
}

export enum LayerSource {
  Workspace = 'workspace',
  Dsm = 'dsm',
}
